import { Typography } from "@packages/ds";
import styled from "styled-components";

import * as Accordion from "ds/Accordion";

export const AppName = styled(Typography.BodyText)`
  color: var(--section-ebony-color, var(--ebony));
  padding: 0 0 8px 0;
`;
export const AppNameWorkers = styled(Typography.BodyText)`
  color: var(--section-ebony-color, var(--ebony));
  padding-bottom: 1px;
  font-size: 13px;
`;

export const AppNameNumber = styled.span`
  color: var(--section-slate-color, var(--slate));
`;

export const Line = styled.div`
  display: flex;
  hr {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
    margin-left: 0px !important;
    width: 100% !important;
    align-self: end !important;
    background-color: var(--mode-border-neutral-default);
  }
`;

export const AccordionHeader = styled(Accordion.Header)`
  margin: 0px !important;
  display: flex;
  justify-content: space-between;
`;

export const Instance = styled(Typography.BodyText)`
  font-size: 13px;
  padding: 4px 0;
  color: var(--section-slate-color, var(--slate));
`;

export const AppNameWrapper = styled.div`
  display: flex;
  align-items: end;
  gap: 8px;
  margin-top: 8px;
`;

export const NoResultWrapper = styled.div`
  padding: 24px 0px;
  font-weight: 600;
  font-size: 14px;
`;
export const Title = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ShowAll = styled(Typography.BodyText)`
  margin: 8px 0;
`;

export const ShowAllButton = styled.button`
  margin: 0 2px;
  border: none;
  background: transparent;
  color: var(--section-color-primary-600-color, var(--color-primary-600));
  font-size: 15px;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
